import * as React from "react";
import { Col, FormGroup, Row } from "react-bootstrap";

import type { Choice } from "../../../../../../../react-components/lu-component/src/index";
import { Checkboxes } from "../../../../../../../react-components/lu-component/src/index";
import { AccordionForm } from "../../../../parts/accodion-form";
import { aestheticMedicineExperienceMTOptions, StrategyGroup } from "../../../../../../../server/models/activity";
import { strategyTargetGroupLabels } from "../../../../../../../label/activity";

type Props = {
	onChange: (name: keyof StrategyGroup, value: any) => void;
	strategyGroup: StrategyGroup;
};

export const AestheticMedicineExperienceMTCheckboxes = React.memo((props: Props) => {
	const { onChange, strategyGroup } = props;
	const defaultShow = React.useMemo(() => {
		const { aestheticMedicineExperienceSpot, aestheticMedicineExperienceTone, aestheticMedicineExperienceAging } =
			strategyGroup;
		if (aestheticMedicineExperienceSpot != null && aestheticMedicineExperienceSpot.length) return true;
		if (aestheticMedicineExperienceTone != null && aestheticMedicineExperienceTone.length) return true;
		if (aestheticMedicineExperienceAging != null && aestheticMedicineExperienceAging.length) return true;
		return false;
	}, [strategyGroup]);

	return (
		<Row>
			<FormGroup as={Col}>
				<AccordionForm
					defaultShow={defaultShow}
					eventKey={"aestheticMedicineExperience"}
					title={strategyTargetGroupLabels.aestheticMedicineExperience}
				>
					{/* 3つ並べる必要がある */}
					<Row style={{ paddingLeft: "15px" }}>
						{(
							[
								"aestheticMedicineExperienceSpot",
								"aestheticMedicineExperienceTone",
								"aestheticMedicineExperienceAging",
							] as const
						).map((key) => {
							return (
								<Col md={4} key={key}>
									{strategyTargetGroupLabels[key]}
									<Checkboxes
										checkeds={strategyGroup[key] ?? []}
										choices={aestheticMedicineExperienceMTOptions as Choice[]}
										name={key}
										onChange={(value) => {
											onChange(key, value);
										}}
									/>
								</Col>
							);
						})}
					</Row>
				</AccordionForm>
			</FormGroup>
		</Row>
	);
});
